/*
  Amazon-style hover magnifier for the main product gallery image.
  Desktop only (hover + fine pointer) - on touch devices this script
  does nothing, the click-to-zoom (PhotoSwipe) modal stays as-is.
*/
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  var ZOOM_FACTOR = 2.5;

  function setupMagnifier(sliderEl) {
    if (sliderEl.dataset.magnifierReady) return;
    sliderEl.dataset.magnifierReady = 'true';

    var lens = document.createElement('div');
    lens.className = 'product-zoom-lens';
    var result = document.createElement('div');
    result.className = 'product-zoom-result';

    sliderEl.style.position = sliderEl.style.position || 'relative';
    sliderEl.appendChild(lens);
    sliderEl.appendChild(result);

    function getActiveImage() {
      // .swiper-slide-active solo existe una vez que Swiper termino de
      // inicializar - antes de eso (primer hover, antes de cualquier
      // click) hay que caer de vuelta al slide marcado por Liquid
      // (data-selected) o simplemente al primero, para que la lupa
      // funcione desde el primer hover sin necesidad de hacer click.
      var activeSlide =
        sliderEl.querySelector('.swiper-slide-active') ||
        sliderEl.querySelector('.swiper-slide[data-selected]') ||
        sliderEl.querySelector('.swiper-slide');
      if (!activeSlide) return null;
      var img = activeSlide.querySelector('.media img');
      if (!img) return null;
      var link = activeSlide.querySelector('a.product__gallery-toggle[data-pswp-src]');
      var zoomSrc = link ? link.getAttribute('data-pswp-src') : img.currentSrc || img.src;
      return { img: img, zoomSrc: zoomSrc };
    }

    function hide() {
      lens.style.display = 'none';
      result.style.display = 'none';
    }

    function move(event) {
      var active = getActiveImage();
      if (!active) {
        hide();
        return;
      }

      var rect = active.img.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        hide();
        return;
      }

      var lensSize = Math.max(80, Math.min(rect.width, rect.height) * 0.25);
      var lensX = Math.min(Math.max(x - lensSize / 2, 0), rect.width - lensSize);
      var lensY = Math.min(Math.max(y - lensSize / 2, 0), rect.height - lensSize);

      lens.style.display = 'block';
      lens.style.width = lensSize + 'px';
      lens.style.height = lensSize + 'px';
      lens.style.left = lensX + 'px';
      lens.style.top = lensY + 'px';

      result.style.display = 'block';
      result.style.backgroundImage = 'url("' + active.zoomSrc + '")';
      result.style.backgroundSize = (rect.width * ZOOM_FACTOR) + 'px ' + (rect.height * ZOOM_FACTOR) + 'px';
      result.style.backgroundPosition =
        '-' + (lensX * ZOOM_FACTOR) + 'px -' + (lensY * ZOOM_FACTOR) + 'px';
    }

    sliderEl.addEventListener('mouseenter', move);
    sliderEl.addEventListener('mousemove', move);
    sliderEl.addEventListener('mouseleave', hide);
  }

  function init() {
    document.querySelectorAll('.main-product__media--slider').forEach(setupMagnifier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
